import AddGroupsContainer from "./AddGroupsContainer";

export default AddGroupsContainer;
